import { useState, useEffect } from "react";
import icon_polygon from "../../../assets/icons/icon_polygon.png";
import { setCookie } from "../../../util";
import TableBody from "./TableBody";
import TableHead from "./TableHead";
import CourseListModal from "./CourseListModal";
import AddCourseModal from "./AddCourseModal";
import { useNavigate } from "react-router-dom";
import "./index.css";
import { storage } from "../../../firebase-config";
import { ref, listAll, getDownloadURL } from "firebase/storage";

function Table({
  data,
  setData,
  headers,
  widths,
  sortBy,
  setSortBy,
  isAscending,
  setIsAscending,
  handleCheckBox,
  handleDownloadExcel,
  sortDataFunc,
  initData,
  setLoading,
  courses,
  getCourses,
  handlePdfOpen,
}) {
  const navigation = useNavigate();
  const [showSortMenu, setShowSortMenu] = useState(false);
  const [showCourses, setShowCourses] = useState(false);
  const [showAddCourse, setShowAddCourse] = useState(false);

  const handleSort = (item, ascend) => {
    setShowSortMenu(false);
    if (item) setSortBy(item);
    sortDataFunc(
      item.id || sortBy.id,
      ascend === undefined ? isAscending : ascend
    );
  };

  const handleDownloadAll = async () => {
    try {
      // Firebase Storage 경로 참조
      const folderRef = ref(storage, "userdata/pdfs");

      // 폴더 내 모든 파일 목록을 한 번에 가져오기
      const result = await listAll(folderRef);

      // 파일들을 순차적으로 처리하기 위해 for...of 루프 사용
      for (const itemRef of result.items) {
        try {
          const url = await getDownloadURL(itemRef); // 다운로드 링크 가져오기
          const response = await fetch(url);
          const fileBlob = await response.blob();

          // 파일 이름 설정 (확장자는 .json으로)
          const fileName = itemRef.name.replace(/\.[^/.]+$/, ".json");

          // Blob을 URL로 변환하여 다운로드 링크 생성
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(fileBlob);
          link.download = fileName; // 다운로드할 파일명 설정
          link.click();

          // 다운로드 확인을 위해 로그 남기기 (선택 사항)
          console.log(`Downloaded: ${fileName}`);
        } catch (downloadError) {
          console.error(`Failed to download ${itemRef.name}:`, downloadError);
        }
      }
    } catch (error) {
      console.error("파일 목록을 가져오는 중 오류 발생:", error);
    }
  };

  useEffect(() => {
    {
      data.map((item, index) => {
        item.idx = index;
      });
    }
    console.log("data:", data);
  }, []);

  if (!data) return;
  return (
    <div className="Table">
      <div className="button-container">
        <div className="buttons">
          <div className="total-number">총 {data.length}명</div>
          <div className="sort-container">
            <button
              className="btn_sort"
              onClick={() => setShowSortMenu(!showSortMenu)}
            >
              {sortBy.name} 순
              <img alt="icon_polygon" src={icon_polygon} />
            </button>
            {showSortMenu && (
              <div className="menu-sort">
                {headers.map(
                  (item, index) =>
                    item.id && (
                      <button
                        key={index}
                        className="btn_sort_item"
                        onClick={() => handleSort(item)}
                      >
                        {item.name} 순
                      </button>
                    )
                )}
              </div>
            )}
            <button
              className="btn_sort"
              onClick={() => {
                handleSort(sortBy, !isAscending);
                setIsAscending(!isAscending);
              }}
            >
              {isAscending ? "오름차순" : "내림차순"}
            </button>
          </div>
          <button className="btn_delete" onClick={() => handleCheckBox("del")}>
            삭제
          </button>
          <button className="btn_group" onClick={() => handleCheckBox("group")}>
            그룹별 요약
          </button>
          <button
            className="btn_group"
            onClick={() => handleCheckBox("download")}
          >
            결과지 일괄 다운로드
          </button>
        </div>
        <div className="buttons">
          <button
            className="btn_storage_download"
            onClick={() => {
              handleDownloadAll();
            }}
          >
            Storage 백업
          </button>
          <button
            className="btn_statistic"
            onClick={() => {
              navigation(`/test`);
              setCookie("statistic", true);
            }}
          >
            통계
          </button>
          <button className="btn_excel" onClick={handleDownloadExcel}>
            전체 Excel 다운로드
          </button>
          <button
            className="btn_add_course"
            onClick={() => setShowCourses(true)}
          >
            과정 관리
          </button>
        </div>
      </div>
      <TableHead data={data} setData={setData} keys={headers} widths={widths} />
      {data.map((item, index) => (
        <TableBody
          key={`${item.company}_${item.affiliation}_${item.position}_${item.name}_${item.course}`}
          tableKey={index}
          userData={item}
          listData={data}
          setListData={setData}
          widths={widths}
          headers={headers}
          courses={courses}
          initData={initData}
          setLoading={setLoading}
          handlePdfOpen={handlePdfOpen}
        />
      ))}
      <CourseListModal
        modalIsOpen={showCourses}
        setModalIsOpen={setShowCourses}
        setShowAddCourse={setShowAddCourse}
        initData={initData}
        courses={courses}
        getCourses={getCourses}
      />
      <AddCourseModal
        modalIsOpen={showAddCourse}
        setModalIsOpen={setShowAddCourse}
        setShowCourses={setShowCourses}
        getCourses={getCourses}
      />
    </div>
  );
}

export default Table;
